import fluxValidation from './validation';
import fluxForm from './form';
import fluxUI from './ui';

var fluxAddressSearch = {},
	fluxAddressAutocomplete,
	fluxAddressAutocompleteShipping;

/**
 * Run.
 */
fluxAddressSearch.init = function() {
	this.initSearch();
	this.watchSelect2();
	jQuery( document.body ).trigger( 'country_to_state_changed' );
};

/**
 * Watch select2 events.
 */
fluxAddressSearch.watchSelect2 = function() {
	jQuery( 'select.country_select' )
	.on( 'select2:open', function( e ) {
		let $select2_above = jQuery( '.select2-dropdown--above' );

		if ( $select2_above.length <= 0 ) {
			return;
		}

		let $field_row = jQuery( this ).closest( '.form-row' ),
			$label = $field_row.find( 'label' );

		$label.hide();
	} )
	.on( 'select2:close', function( e ) {
		let $field_row = jQuery( this ).closest( '.form-row' ),
			$label = $field_row.find( 'label' );

		$label.show();
	} );
};

/**
 * Initialise the Address Search.
 */
fluxAddressSearch.initSearch = function() {
	fluxAddressSearch.handleManualButtonClick();

	var billingAddressSearch = document.getElementById( 'billing_address_search' );
	var shippingAddressSearch = document.getElementById( 'shipping_address_search' );

	if ( !billingAddressSearch && !shippingAddressSearch ) {
		return;
	}

	// Create the autocomplete object, restricting the search to geographical
	// location types.
	var options = {
		types: [ 'geocode' ]
	};

	// Only limits to the first 5 countries, so if there's more than 5, it's
	// best to just ignore this setting.
	if ( flux_checkout_vars.allowed_countries.length <= 5 ) {
		options.componentRestrictions = { country: flux_checkout_vars.allowed_countries };
	}

	if ( billingAddressSearch ) {
		fluxAddressAutocomplete = new google.maps.places.Autocomplete(
			billingAddressSearch,
			options
		);

		// When the user selects an address from the dropdown, populate the address
		// fields in the form.
		fluxAddressAutocomplete.addListener( 'place_changed', function () {
			var place = fluxAddressAutocomplete.getPlace();
			fluxAddressSearch.fillInAddress( place, 'billing' );
		} );
		billingAddressSearch.addEventListener( 'focus', fluxAddressSearch.preventAutocomplete );
	}

	if ( shippingAddressSearch ) {
		fluxAddressAutocompleteShipping = new google.maps.places.Autocomplete(
			shippingAddressSearch,
			options
		);

		// When the user selects an address from the dropdown, populate the address
		// fields in the form.
		fluxAddressAutocompleteShipping.addListener( 'place_changed', function () {
			fluxAddressSearch.fillInAddress( fluxAddressAutocompleteShipping.getPlace(), 'shipping' );
		} );
		shippingAddressSearch.addEventListener( 'focus', fluxAddressSearch.preventAutocomplete );
	}
};

/**
 * Prevent Autocomplete on the Search Field.
 *
 * @param {object} e Event.
 */
fluxAddressSearch.preventAutocomplete = function( e ) {
	// e.target.setAttribute( 'autocomplete', 'new-password' );
};

/**
 * Fill in the Billing Address Fields.
 */
fluxAddressSearch.fillInAddress = function( place, type ) {

	var formFieldsValue = {},
		component_form = {
			// types : [ field html id, short or long name ]
			'street_number':               [ `${type}_street_number`, 'short_name' ],
			'route':                       [ `${type}_address_1`, 'long_name' ],
			'locality':                    [ `${type}_city`, 'long_name' ],
			'sublocality_level_1':         [ `${type}_neighborhood`, 'long_name' ],
			'administrative_area_level_1': [ `${type}_state`, 'short_name' ],
			'administrative_area_level_2': [ `administrative_area_level_2`, 'long_name' ],
			'postal_town':                 [ `${type}_city`, 'long_name' ],
			'country':                     [ `${type}_country`, 'long_name' ],
			'postal_code':                 [ `${type}_postcode`, 'short_name' ]
		},
		streetNumber = '',
		country_code = '';
		
	console.log( place );

	var isModern = document.querySelectorAll( '.flux-checkout--modern' ).length;

	for ( var field in place.address_components ) {
		for ( var address_type in place.address_components[ field ].types ) {
			for ( var component_key in component_form ) {
				var types = place.address_components[ field ].types;
				var prop;
				if ( component_key === types[ address_type ] ) {
					if ( component_key === 'street_number' ) {
						streetNumber = place.address_components[ field ][ 'short_name' ];
					} else if ( component_key === 'country' ) {
						prop = component_form[ component_key ][ 1 ];
						if ( place.address_components[ field ].hasOwnProperty( prop ) ) {
							country_code = place.address_components[ field ][ "short_name" ];
						}
					} else {
						if ( document.getElementById( `${type}_country` ).value === "KR" ) {
							streetNumber = place.address_components[ 0 ][ 'short_name' ];
							streetNumber += "," + place.address_components[ 1 ][ 'long_name' ];
						}
					}

					prop = component_form[ component_key ][ 1 ];
					if ( place.address_components[ field ].hasOwnProperty( prop ) ) {
						formFieldsValue[ component_form[ component_key ][ 0 ] ] = place.address_components[ field ][ prop ];
					}
				}
			}
		}
	}

	// Support for Brazilian Market on WooCommerce.
	formFieldsValue[`${type}_number`] = formFieldsValue[`${type}_street_number`];

	if ( !formFieldsValue[`${type}_city`] && formFieldsValue.administrative_area_level_2 && formFieldsValue.administrative_area_level_2 !== formFieldsValue[`${type}_country`] ) {
		formFieldsValue[`${type}_city`] = formFieldsValue.administrative_area_level_2;
	}

	if ( place.address_components[ 0 ].types.includes( 'subpremise' ) ) {
		formFieldsValue[`${type}_street_number`] = place.address_components[ 0 ].long_name + '/' + formFieldsValue[`${type}_street_number`];
	}

	if ( 0 === jQuery( `#${type}_street_number` ).length ) {
		if ( formFieldsValue[ `${type}_street_number` ] ) {
			formFieldsValue[ `${type}_address_1` ] = formFieldsValue[ `${type}_street_number` ] + ' ' + formFieldsValue[ `${type}_address_1` ];
		}

		var match = place.adr_address.match( /<span.*class="street-address">(.*?)<\/span>/m );
		if ( match && match[ 1 ] ) {
			formFieldsValue[`${type}_address_1`] = match[ 1 ];
		}
	} 

	if ( jQuery( `#${type}_state` ).is( "input" ) ) {
		var level_1 = fluxAddressSearch.getAddressComponent( place.address_components, 'administrative_area_level_1' );
		var level_2 = fluxAddressSearch.getAddressComponent( place.address_components, 'administrative_area_level_2' );
		var locality = fluxAddressSearch.getAddressComponent( place.address_components, 'locality' );
		var state = level_2 ? level_2 : ( level_1 === locality ? '' : level_1 );
		formFieldsValue[ `${type}_state` ] = state;
	}

	for ( var f in formFieldsValue ) {
		if ( f === `${type}_country` ) {
			if ( document.getElementById( f ) === null ) {
				return false;
			}

			var el = document.getElementById( f ),
				eltype = el.nodeName;

			if ( eltype === 'SELECT' ) {
				for ( var i = 0; i < el.options.length; i ++ ) {
					if ( el.options[ i ].text === formFieldsValue[ f ] || el.options[ i ].value === country_code ) {
						el.selectedIndex = i;
						var event = new CustomEvent( 'change' );
						document.getElementById( f ).dispatchEvent( event );
						document.getElementById( f ).closest( '.form-row' ).classList.add( 'is-dirty' );
						break;
					}
				}
			}
		} else {
			if ( document.getElementById( f ) === null ) {
				continue;
			} else {
				document.getElementById( f ).value = formFieldsValue[ f ];
				var val = formFieldsValue[ f ];
				if ( f === `${type}_state` ) {
					jQuery( document ).one(
						'country_to_state_changed',
						{
							field: f,
							value: formFieldsValue[ f ]
						},
						function ( event ) {
							window.setTimeout( () => {
								jQuery( '#' + event.data.field ).val( event.data.value );
								jQuery( '#' + event.data.field ).trigger( 'change' );
							}, 200 );
						}
					);
				}
				var event = new CustomEvent( 'change' );
				document.getElementById( f ).dispatchEvent( event );
				document.getElementById( f ).closest( '.form-row' ).classList.add( 'is-dirty' );
			}
		}
	}

	if ( place.vicinity && place.vicinity !== formFieldsValue[ `${type}_city` ] ) {
		jQuery( `#${type}_address_2` ).val( place.vicinity );
	}

	var billingFields = document.querySelectorAll( `.woocommerce-${type}-fields` );
	var showManualBillingFieldsButtons = document.querySelectorAll( `.flux-address-button-wrapper--${type}-manual` );

	if ( !billingFields.length ) {
		return;
	}

	Array.from( billingFields ).forEach( function( field ) {
		field.style.display = 'block';

		Array.from( field.querySelectorAll( 'input, select' ) ).forEach( function( input ) {
			if ( input.value ) {
				input.parentElement.classList.add( 'is-dirty' );
			} else {
				input.parentElement.classList.remove( 'is-dirty' );
			}
			if ( input.attributes[ 'placeholder' ] ) {
				input.parentElement.classList.add( 'has-placeholder' );
			} else {
				input.parentElement.classList.remove( 'has-placeholder' );
			}
			if ( input.parentElement.classList.contains( '.validate-required' ) ) {
				input.parentElement.classList.remove( 'is-invalid' );
			}
		} );

		if ( isModern ) {
			let field_wrapper = field.closest( `.woocommerce-${type}-fields__wrapper` );
			if ( field_wrapper ) {
				field_wrapper.querySelector( `.${type}-address-search` ).style.display = 'none';
			}
		}
	} );

	if ( isModern ) {
		Array.from( showManualBillingFieldsButtons ).forEach( function( button ) {
			button.closest( `.${type}-address-search` ).style.display = 'none';
		} );
	}

	// Woo trigger select2 reload.
	jQuery( document.body ).trigger( 'country_to_state_changed' );
	jQuery( ".country_to_state" ).trigger( 'change' );

	fluxValidation.clearErrorMessages();
	fluxForm.onActiveField();
};

/**
 * Handle Manual Address clicks.
 */
fluxAddressSearch.handleManualButtonClick = function() {
	var showManualBillingFieldsButtons = document.querySelectorAll( '.flux-address-button--billing-manual' );
	var showManualShippingFieldsButtons = document.querySelectorAll( '.flux-address-button--shipping-manual' );
	var openBillingSearchFieldButtons = document.querySelectorAll( '.flux-address-button--billing-lookup' );
	var openShippingSearchFieldButtons = document.querySelectorAll( '.flux-address-button--shipping-lookup' );
	var isModern = document.querySelectorAll( '.flux-checkout--modern' ).length;

	Array.from( showManualBillingFieldsButtons ).forEach( function( button ) {
		button.addEventListener( 'click', function( e ) {
			e.preventDefault();

			var panel = e.target.closest( '.billing-address-search' ).parentElement.querySelector( '.billing-address-search + .woocommerce-billing-fields' );

			if ( 'block' !== panel.style.display ) {
				fluxUI.slideDown( panel );
				if ( isModern ) {
					fluxUI.slideUp( button.closest( '.billing-address-search' ) );
				}
			} else {
				fluxUI.slideUp( panel );
			}

			// Woo trigger select2 reload.
			jQuery( document.body ).trigger( 'country_to_state_changed' );

			return false;
		} );
	} );

	Array.from( openBillingSearchFieldButtons ).forEach( function( button ) {
		button.addEventListener( 'click', function( e ) {
			e.preventDefault();

			fluxUI.slideUp( button.closest( '.woocommerce-billing-fields' ) );
			fluxUI.slideDown( button.closest( '.woocommerce-billing-fields__wrapper' ).querySelector( '.billing-address-search' ) );

			// Woo trigger select2 reload.
			jQuery( document.body ).trigger( 'country_to_state_changed' );

			return false;
		} );
	} );

	Array.from( showManualShippingFieldsButtons ).forEach( function( button ) {
		button.addEventListener( 'click', function( e ) {
			e.preventDefault();

			var panel = e.target.closest( '.shipping-address-search' ).parentElement.querySelector( '.shipping-address-search + .woocommerce-shipping-fields' );

			if ( 'block' !== panel.style.display ) {
				fluxUI.slideDown( panel );
				if ( isModern ) {
					fluxUI.slideUp( button.closest( '.shipping-address-search' ) );
				}
			} else {
				fluxUI.slideUp( panel );
			}

			// Woo trigger select2 reload.
			jQuery( document.body ).trigger( 'country_to_state_changed' );

			return false;
		} );
	} );

	Array.from( openShippingSearchFieldButtons ).forEach( function( button ) {
		button.addEventListener( 'click', function( e ) {
			e.preventDefault();

			fluxUI.slideUp( button.closest( '.woocommerce-shipping-fields' ) );
			fluxUI.slideDown( button.closest( '.woocommerce-shipping-fields__wrapper' ).querySelector( '.shipping-address-search' ) );

			// Woo trigger select2 reload.
			jQuery( document.body ).trigger( 'country_to_state_changed' );

			return false;
		} );
	} );
};

fluxAddressSearch.getAddressComponent = function ( components, component ) {
	for ( var loop_component of components ) {
		if ( loop_component.types.includes( component ) ) {
			return loop_component.long_name;
		}
	}

	return '';
};

export default fluxAddressSearch;